class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this._interval = null;
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    const endStr = this.dataset.end;
    if (!endStr) return;

    this.endDate = this._parseDate(endStr);
    if (!this.endDate || isNaN(this.endDate.getTime())) {
      this.remove();
      return;
    }

    // se já estiver esgotado, não mostra nada
    const now = new Date();
    if (this.endDate <= now) {
      this.remove();
      return;
    }

    this.startText = this.dataset.startText || "O preço voltará para";
    this.entreText = this.dataset.entreText || "em";
    this.comparePrice = this.dataset.comparePrice || "";
    this.inPreviewCart = !!this.closest(".previewCartList");

    this._render();
    this._start();
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }

  _parseDate(str) {
    // Espera "YYYY-MM-DD HH:MM:SS"
    const [datePart, timePart = "00:00:00"] = str.split(" ");
    const [y, m, d] = datePart.split("-").map(Number);
    const [hh, mm, ss = 0] = timePart.split(":").map(Number);
    return new Date(y, m - 1, d, hh, mm, ss);
  }

  _render() {
    const wrapper = document.createElement("div");
    wrapper.className =
      "countdown-box" +
      (this.inPreviewCart
        ? " countdown-box--preview"
        : " countdown-box--preview");
    wrapper.innerHTML = `
      <style>
        .countdown-box {
          border-radius: 0;
          padding: 0;
          background: transparent;
          border: 0;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          display: inline-block;
          margin-bottom: 15px;
          max-width: 400px;
          justify-content: space-between;
        }
          
        .countdown-box--preview {
            width: 100%;
            background: #e5e5e5;
            display: flex;
            align-items: center;
            padding: 7px 15px 7px;
            box-sizing: border-box;
            border-radius: 7px;
            position: relative;
        }
            
        .countdown-box--preview::after {
          content: "";
          position: absolute;
          left: 10px;   
          bottom: -10px;   
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 10px solid #e5e5e5;
        }
        .countdown-label {
          font-size: 13px;
          margin-bottom: 6px;
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          align-items: baseline;
        }
            
        .countdown-box--preview .countdown-label {
            margin-bottom: 0;
            display: inline-block;
            margin-right: 10px;
            line-height: 1.3;
        }
        .countdown-label .start-text { font-weight: 400; }
        .countdown-label .compare-price {
          font-weight: 600;
          color: #d32f2f;
        }
        .countdown-label .entre-text { opacity: 0.8; }
        .countdown-timer {
          display: flex;
          gap: 6px;
          font-size: 11px;
          text-transform: uppercase;
        }
        .time-part {
          background: #f7f7f7;
          border-radius: 6px;
          padding: 4px 6px;
          text-align: center;
          min-width: 52px;
        }
        .time-part .value {
          font-size: 19px;
          font-weight: 700;
          line-height: 1.1;
        }
        .time-part .label {
          font-size: 11px;
          opacity: 0.7;
        }
      </style>

      <div class="countdown-label">
        <span class="start-text">${this.startText} <br/></span>
        <span class="compare-price">${this.comparePrice}</span>
        <span class="entre-text">${this.entreText}:</span>
      </div>

      <div class="countdown-timer">
        ${this._block("days", "dias")}
        ${this._block("hours", "horas")}
        ${this._block("minutes", "minutos")}
        ${this._block("seconds", "segundos")}
      </div>
    `;

    this.shadowRoot.innerHTML = "";
    this.shadowRoot.appendChild(wrapper);

    this.$days = this.shadowRoot.querySelector('[data-part="days"]');
    this.$daysWrapper = this.shadowRoot.querySelector('[data-wrapper="days"]');
    this.$hours = this.shadowRoot.querySelector('[data-part="hours"]');
    this.$minutes = this.shadowRoot.querySelector('[data-part="minutes"]');
    this.$seconds = this.shadowRoot.querySelector('[data-part="seconds"]');
  }

  _block(part, label) {
    return `
      <div class="time-part" data-wrapper="${part}">
        <div class="value" data-part="${part}">00</div>
        <div class="label">${label}</div>
      </div>
    `;
  }

  _start() {
    const update = () => {
      const now = new Date();
      let diff = Math.floor((this.endDate - now) / 1000);

      // se esgotou durante a navegação, remove o elemento
      if (diff <= 0) {
        clearInterval(this._interval);
        this.remove();
        return;
      }

      const days = Math.floor(diff / 86400);
      diff -= days * 86400;
      const hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff - minutes * 60;

      // mostra/esconde bloco de dias
      if (this.$daysWrapper) {
        this.$daysWrapper.style.display = days > 0 ? "" : "none";
      }

      this.$days.textContent = String(days).padStart(2, "0");
      this.$hours.textContent = String(hours).padStart(2, "0");
      this.$minutes.textContent = String(minutes).padStart(2, "0");
      this.$seconds.textContent = String(seconds).padStart(2, "0");
    };

    update();
    this._interval = setInterval(update, 1000);
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}
